import { html as m, when as o } from "@microsoft/fast-element";
import e from "./outline/academic-cap.js";
import a from "./outline/adjustments-horizontal.js";
import n from "./outline/adjustments-vertical.js";
import t from "./outline/archive-box-arrow-down.js";
import i from "./outline/archive-box-x-mark.js";
import p from "./outline/archive-box.js";
import f from "./outline/arrow-down-circle.js";
import l from "./outline/arrow-down-left.js";
import c from "./outline/arrow-down-on-square-stack.js";
import $ from "./outline/arrow-down-on-square.js";
import u from "./outline/arrow-down-right.js";
import s from "./outline/arrow-down-tray.js";
import w from "./outline/arrow-down.js";
import h from "./outline/arrow-left-circle.js";
import d from "./outline/arrow-left-end-on-rectangle.js";
import g from "./outline/arrow-left-on-rectangle.js";
import b from "./outline/arrow-left-start-on-rectangle.js";
import C from "./outline/arrow-left.js";
import k from "./outline/arrow-long-down.js";
import A from "./outline/arrow-long-left.js";
import y from "./outline/arrow-long-right.js";
import S from "./outline/arrow-long-up.js";
import B from "./outline/arrow-path-rounded-square.js";
import D from "./outline/arrow-path.js";
import v from "./outline/arrow-right-circle.js";
import L from "./outline/arrow-right-end-on-rectangle.js";
import P from "./outline/arrow-right-on-rectangle.js";
import R from "./outline/arrow-right-start-on-rectangle.js";
import U from "./outline/arrow-right.js";
import q from "./outline/arrow-small-down.js";
import T from "./outline/arrow-small-left.js";
import x from "./outline/arrow-small-right.js";
import M from "./outline/arrow-small-up.js";
import O from "./outline/arrow-top-right-on-square.js";
import E from "./outline/arrow-trending-down.js";
import F from "./outline/arrow-trending-up.js";
import G from "./outline/arrow-turn-down-left.js";
import H from "./outline/arrow-turn-down-right.js";
import z from "./outline/arrow-turn-left-down.js";
import I from "./outline/arrow-turn-left-up.js";
import V from "./outline/arrow-turn-right-down.js";
import W from "./outline/arrow-turn-right-up.js";
import X from "./outline/arrow-turn-up-left.js";
import j from "./outline/arrow-turn-up-right.js";
import N from "./outline/arrow-up-circle.js";
import Q from "./outline/arrow-up-left.js";
import Y from "./outline/arrow-up-on-square-stack.js";
import K from "./outline/arrow-up-on-square.js";
import J from "./outline/arrow-up-right.js";
import Z from "./outline/arrow-up-tray.js";
import _ from "./outline/arrow-up.js";
import rr from "./outline/arrow-uturn-down.js";
import or from "./outline/arrow-uturn-left.js";
import mr from "./outline/arrow-uturn-right.js";
import er from "./outline/arrow-uturn-up.js";
import ar from "./outline/arrows-pointing-in.js";
import nr from "./outline/arrows-pointing-out.js";
import tr from "./outline/arrows-right-left.js";
import ir from "./outline/arrows-up-down.js";
import pr from "./outline/at-symbol.js";
import fr from "./outline/backspace.js";
import lr from "./outline/backward.js";
import cr from "./outline/banknotes.js";
import $r from "./outline/bars-2.js";
import ur from "./outline/bars-3-bottom-left.js";
import sr from "./outline/bars-3-bottom-right.js";
import wr from "./outline/bars-3-center-left.js";
import hr from "./outline/bars-3.js";
import dr from "./outline/bars-4.js";
import gr from "./outline/bars-arrow-down.js";
import br from "./outline/bars-arrow-up.js";
import Cr from "./outline/battery-0.js";
import kr from "./outline/battery-100.js";
import Ar from "./outline/battery-50.js";
import yr from "./outline/beaker.js";
import Sr from "./outline/bell-alert.js";
import Br from "./outline/bell-slash.js";
import Dr from "./outline/bell-snooze.js";
import vr from "./outline/bell.js";
import Lr from "./outline/bold.js";
import Pr from "./outline/bolt-slash.js";
import Rr from "./outline/bolt.js";
import Ur from "./outline/book-open.js";
import qr from "./outline/bookmark-slash.js";
import Tr from "./outline/bookmark-square.js";
import xr from "./outline/bookmark.js";
import Mr from "./outline/briefcase.js";
import Or from "./outline/bug-ant.js";
import Er from "./outline/building-library.js";
import Fr from "./outline/building-office-2.js";
import Gr from "./outline/building-office.js";
import Hr from "./outline/building-storefront.js";
import zr from "./outline/cake.js";
import Ir from "./outline/calculator.js";
import Vr from "./outline/calendar-date-range.js";
import Wr from "./outline/calendar-days.js";
import Xr from "./outline/calendar.js";
import jr from "./outline/camera.js";
import Nr from "./outline/chart-bar-square.js";
import Qr from "./outline/chart-bar.js";
import Yr from "./outline/chart-pie.js";
import Kr from "./outline/chat-bubble-bottom-center-text.js";
import Jr from "./outline/chat-bubble-bottom-center.js";
import Zr from "./outline/chat-bubble-left-ellipsis.js";
import _r from "./outline/chat-bubble-left-right.js";
import ro from "./outline/chat-bubble-left.js";
import oo from "./outline/chat-bubble-oval-left-ellipsis.js";
import mo from "./outline/chat-bubble-oval-left.js";
import eo from "./outline/check-badge.js";
import ao from "./outline/check-circle.js";
import no from "./outline/check.js";
import to from "./outline/chevron-double-down.js";
import io from "./outline/chevron-double-left.js";
import po from "./outline/chevron-double-right.js";
import fo from "./outline/chevron-double-up.js";
import lo from "./outline/chevron-down.js";
import co from "./outline/chevron-left.js";
import $o from "./outline/chevron-right.js";
import uo from "./outline/chevron-up-down.js";
import so from "./outline/chevron-up.js";
import wo from "./outline/circle-stack.js";
import ho from "./outline/clipboard-document-check.js";
import go from "./outline/clipboard-document-list.js";
import bo from "./outline/clipboard-document.js";
import Co from "./outline/clipboard.js";
import ko from "./outline/clock.js";
import Ao from "./outline/cloud-arrow-down.js";
import yo from "./outline/cloud-arrow-up.js";
import So from "./outline/cloud.js";
import Bo from "./outline/code-bracket-square.js";
import Do from "./outline/code-bracket.js";
import vo from "./outline/cog-6-tooth.js";
import Lo from "./outline/cog-8-tooth.js";
import Po from "./outline/cog.js";
import Ro from "./outline/command-line.js";
import Uo from "./outline/computer-desktop.js";
import qo from "./outline/cpu-chip.js";
import To from "./outline/credit-card.js";
import xo from "./outline/cube-transparent.js";
import Mo from "./outline/cube.js";
import Oo from "./outline/currency-bangladeshi.js";
import Eo from "./outline/currency-dollar.js";
import Fo from "./outline/currency-euro.js";
import Go from "./outline/currency-pound.js";
import Ho from "./outline/currency-rupee.js";
import zo from "./outline/currency-yen.js";
import Io from "./outline/cursor-arrow-rays.js";
import Vo from "./outline/cursor-arrow-ripple.js";
import Wo from "./outline/device-phone-mobile.js";
import Xo from "./outline/device-tablet.js";
import jo from "./outline/divide.js";
import No from "./outline/document-arrow-down.js";
import Qo from "./outline/document-arrow-up.js";
import Yo from "./outline/document-chart-bar.js";
import Ko from "./outline/document-check.js";
import Jo from "./outline/document-currency-bangladeshi.js";
import Zo from "./outline/document-currency-dollar.js";
import _o from "./outline/document-currency-euro.js";
import rm from "./outline/document-currency-pound.js";
import om from "./outline/document-currency-rupee.js";
import mm from "./outline/document-currency-yen.js";
import em from "./outline/document-duplicate.js";
import am from "./outline/document-magnifying-glass.js";
import nm from "./outline/document-minus.js";
import tm from "./outline/document-plus.js";
import im from "./outline/document-text.js";
import pm from "./outline/document.js";
import fm from "./outline/ellipsis-horizontal-circle.js";
import lm from "./outline/ellipsis-horizontal.js";
import cm from "./outline/ellipsis-vertical.js";
import $m from "./outline/envelope-open.js";
import um from "./outline/envelope.js";
import sm from "./outline/equals.js";
import wm from "./outline/exclamation-circle.js";
import hm from "./outline/exclamation-triangle.js";
import dm from "./outline/eye-dropper.js";
import gm from "./outline/eye-slash.js";
import bm from "./outline/eye.js";
import Cm from "./outline/face-frown.js";
import km from "./outline/face-smile.js";
import Am from "./outline/film.js";
import ym from "./outline/finger-print.js";
import Sm from "./outline/fire.js";
import Bm from "./outline/flag.js";
import Dm from "./outline/folder-arrow-down.js";
import vm from "./outline/folder-minus.js";
import Lm from "./outline/folder-open.js";
import Pm from "./outline/folder-plus.js";
import Rm from "./outline/folder.js";
import Um from "./outline/forward.js";
import qm from "./outline/funnel.js";
import Tm from "./outline/gif.js";
import xm from "./outline/gift-top.js";
import Mm from "./outline/gift.js";
import Om from "./outline/globe-alt.js";
import Em from "./outline/globe-americas.js";
import Fm from "./outline/globe-asia-australia.js";
import Gm from "./outline/globe-europe-africa.js";
import Hm from "./outline/h1.js";
import zm from "./outline/h2.js";
import Im from "./outline/h3.js";
import Vm from "./outline/hand-raised.js";
import Wm from "./outline/hand-thumb-down.js";
import Xm from "./outline/hand-thumb-up.js";
import jm from "./outline/hashtag.js";
import Nm from "./outline/heart.js";
import Qm from "./outline/home-modern.js";
import Ym from "./outline/home.js";
import Km from "./outline/identification.js";
import Jm from "./outline/inbox-arrow-down.js";
import Zm from "./outline/inbox-stack.js";
import _m from "./outline/inbox.js";
import re from "./outline/information-circle.js";
import oe from "./outline/italic.js";
import me from "./outline/key.js";
import ee from "./outline/language.js";
import ae from "./outline/lifebuoy.js";
import ne from "./outline/light-bulb.js";
import te from "./outline/link-slash.js";
import ie from "./outline/link.js";
import pe from "./outline/list-bullet.js";
import fe from "./outline/lock-closed.js";
import le from "./outline/lock-open.js";
import ce from "./outline/magnifying-glass-circle.js";
import $e from "./outline/magnifying-glass-minus.js";
import ue from "./outline/magnifying-glass-plus.js";
import se from "./outline/magnifying-glass.js";
import we from "./outline/map-pin.js";
import he from "./outline/map.js";
import de from "./outline/megaphone.js";
import ge from "./outline/microphone.js";
import be from "./outline/minus-circle.js";
import Ce from "./outline/minus-small.js";
import ke from "./outline/minus.js";
import Ae from "./outline/moon.js";
import ye from "./outline/musical-note.js";
import Se from "./outline/newspaper.js";
import Be from "./outline/no-symbol.js";
import De from "./outline/numbered-list.js";
import ve from "./outline/paint-brush.js";
import Le from "./outline/paper-airplane.js";
import Pe from "./outline/paper-clip.js";
import Re from "./outline/pause-circle.js";
import Ue from "./outline/pause.js";
import qe from "./outline/pencil-square.js";
import Te from "./outline/pencil.js";
import xe from "./outline/percent-badge.js";
import Me from "./outline/phone-arrow-down-left.js";
import Oe from "./outline/phone-arrow-up-right.js";
import Ee from "./outline/phone-x-mark.js";
import Fe from "./outline/phone.js";
import Ge from "./outline/photo.js";
import He from "./outline/play-circle.js";
import ze from "./outline/play-pause.js";
import Ie from "./outline/play.js";
import Ve from "./outline/plus-circle.js";
import We from "./outline/plus-small.js";
import Xe from "./outline/plus.js";
import je from "./outline/power.js";
import Ne from "./outline/presentation-chart-bar.js";
import Qe from "./outline/presentation-chart-line.js";
import Ye from "./outline/printer.js";
import Ke from "./outline/puzzle-piece.js";
import Je from "./outline/qr-code.js";
import Ze from "./outline/question-mark-circle.js";
import _e from "./outline/queue-list.js";
import ra from "./outline/radio.js";
import oa from "./outline/receipt-percent.js";
import ma from "./outline/receipt-refund.js";
import ea from "./outline/rectangle-group.js";
import aa from "./outline/rectangle-stack.js";
import na from "./outline/rocket-launch.js";
import ta from "./outline/rss.js";
import ia from "./outline/scale.js";
import pa from "./outline/scissors.js";
import fa from "./outline/server-stack.js";
import la from "./outline/server.js";
import ca from "./outline/share.js";
import $a from "./outline/shield-check.js";
import ua from "./outline/shield-exclamation.js";
import sa from "./outline/shopping-bag.js";
import wa from "./outline/shopping-cart.js";
import ha from "./outline/signal-slash.js";
import da from "./outline/signal.js";
import ga from "./outline/slash.js";
import ba from "./outline/sparkles.js";
import Ca from "./outline/speaker-wave.js";
import ka from "./outline/speaker-x-mark.js";
import Aa from "./outline/square-2-stack.js";
import ya from "./outline/square-3-stack-3d.js";
import Sa from "./outline/squares-2x2.js";
import Ba from "./outline/squares-plus.js";
import Da from "./outline/star.js";
import va from "./outline/stop-circle.js";
import La from "./outline/stop.js";
import Pa from "./outline/strikethrough.js";
import Ra from "./outline/sun.js";
import Ua from "./outline/swatch.js";
import qa from "./outline/table-cells.js";
import Ta from "./outline/tag.js";
import xa from "./outline/ticket.js";
import Ma from "./outline/trash.js";
import Oa from "./outline/trophy.js";
import Ea from "./outline/truck.js";
import Fa from "./outline/tv.js";
import Ga from "./outline/underline.js";
import Ha from "./outline/user-circle.js";
import za from "./outline/user-group.js";
import Ia from "./outline/user-minus.js";
import Va from "./outline/user-plus.js";
import Wa from "./outline/user.js";
import Xa from "./outline/users.js";
import ja from "./outline/variable.js";
import Na from "./outline/video-camera-slash.js";
import Qa from "./outline/video-camera.js";
import Ya from "./outline/view-columns.js";
import Ka from "./outline/viewfinder-circle.js";
import Ja from "./outline/wallet.js";
import Za from "./outline/wifi.js";
import _a from "./outline/window.js";
import rn from "./outline/wrench-screwdriver.js";
import on from "./outline/wrench.js";
import mn from "./outline/x-circle.js";
import en from "./outline/x-mark.js";
const ic = m`
 ${o((r) => r.name === "academic-cap", e)}
 ${o((r) => r.name === "adjustments-horizontal", a)}
 ${o((r) => r.name === "adjustments-vertical", n)}
 ${o((r) => r.name === "archive-box-arrow-down", t)}
 ${o((r) => r.name === "archive-box-x-mark", i)}
 ${o((r) => r.name === "archive-box", p)}
 ${o((r) => r.name === "arrow-down-circle", f)}
 ${o((r) => r.name === "arrow-down-left", l)}
 ${o((r) => r.name === "arrow-down-on-square-stack", c)}
 ${o((r) => r.name === "arrow-down-on-square", $)}
 ${o((r) => r.name === "arrow-down-right", u)}
 ${o((r) => r.name === "arrow-down-tray", s)}
 ${o((r) => r.name === "arrow-down", w)}
 ${o((r) => r.name === "arrow-left-circle", h)}
 ${o((r) => r.name === "arrow-left-end-on-rectangle", d)}
 ${o((r) => r.name === "arrow-left-on-rectangle", g)}
 ${o((r) => r.name === "arrow-left-start-on-rectangle", b)}
 ${o((r) => r.name === "arrow-left", C)}
 ${o((r) => r.name === "arrow-long-down", k)}
 ${o((r) => r.name === "arrow-long-left", A)}
 ${o((r) => r.name === "arrow-long-right", y)}
 ${o((r) => r.name === "arrow-long-up", S)}
 ${o((r) => r.name === "arrow-path-rounded-square", B)}
 ${o((r) => r.name === "arrow-path", D)}
 ${o((r) => r.name === "arrow-right-circle", v)}
 ${o((r) => r.name === "arrow-right-end-on-rectangle", L)}
 ${o((r) => r.name === "arrow-right-on-rectangle", P)}
 ${o((r) => r.name === "arrow-right-start-on-rectangle", R)}
 ${o((r) => r.name === "arrow-right", U)}
 ${o((r) => r.name === "arrow-small-down", q)}
 ${o((r) => r.name === "arrow-small-left", T)}
 ${o((r) => r.name === "arrow-small-right", x)}
 ${o((r) => r.name === "arrow-small-up", M)}
 ${o((r) => r.name === "arrow-top-right-on-square", O)}
 ${o((r) => r.name === "arrow-trending-down", E)}
 ${o((r) => r.name === "arrow-trending-up", F)}
 ${o((r) => r.name === "arrow-turn-down-left", G)}
 ${o((r) => r.name === "arrow-turn-down-right", H)}
 ${o((r) => r.name === "arrow-turn-left-down", z)}
 ${o((r) => r.name === "arrow-turn-left-up", I)}
 ${o((r) => r.name === "arrow-turn-right-down", V)}
 ${o((r) => r.name === "arrow-turn-right-up", W)}
 ${o((r) => r.name === "arrow-turn-up-left", X)}
 ${o((r) => r.name === "arrow-turn-up-right", j)}
 ${o((r) => r.name === "arrow-up-circle", N)}
 ${o((r) => r.name === "arrow-up-left", Q)}
 ${o((r) => r.name === "arrow-up-on-square-stack", Y)}
 ${o((r) => r.name === "arrow-up-on-square", K)}
 ${o((r) => r.name === "arrow-up-right", J)}
 ${o((r) => r.name === "arrow-up-tray", Z)}
 ${o((r) => r.name === "arrow-up", _)}
 ${o((r) => r.name === "arrow-uturn-down", rr)}
 ${o((r) => r.name === "arrow-uturn-left", or)}
 ${o((r) => r.name === "arrow-uturn-right", mr)}
 ${o((r) => r.name === "arrow-uturn-up", er)}
 ${o((r) => r.name === "arrows-pointing-in", ar)}
 ${o((r) => r.name === "arrows-pointing-out", nr)}
 ${o((r) => r.name === "arrows-right-left", tr)}
 ${o((r) => r.name === "arrows-up-down", ir)}
 ${o((r) => r.name === "at-symbol", pr)}
 ${o((r) => r.name === "backspace", fr)}
 ${o((r) => r.name === "backward", lr)}
 ${o((r) => r.name === "banknotes", cr)}
 ${o((r) => r.name === "bars-2", $r)}
 ${o((r) => r.name === "bars-3-bottom-left", ur)}
 ${o((r) => r.name === "bars-3-bottom-right", sr)}
 ${o((r) => r.name === "bars-3-center-left", wr)}
 ${o((r) => r.name === "bars-3", hr)}
 ${o((r) => r.name === "bars-4", dr)}
 ${o((r) => r.name === "bars-arrow-down", gr)}
 ${o((r) => r.name === "bars-arrow-up", br)}
 ${o((r) => r.name === "battery-0", Cr)}
 ${o((r) => r.name === "battery-100", kr)}
 ${o((r) => r.name === "battery-50", Ar)}
 ${o((r) => r.name === "beaker", yr)}
 ${o((r) => r.name === "bell-alert", Sr)}
 ${o((r) => r.name === "bell-slash", Br)}
 ${o((r) => r.name === "bell-snooze", Dr)}
 ${o((r) => r.name === "bell", vr)}
 ${o((r) => r.name === "bold", Lr)}
 ${o((r) => r.name === "bolt-slash", Pr)}
 ${o((r) => r.name === "bolt", Rr)}
 ${o((r) => r.name === "book-open", Ur)}
 ${o((r) => r.name === "bookmark-slash", qr)}
 ${o((r) => r.name === "bookmark-square", Tr)}
 ${o((r) => r.name === "bookmark", xr)}
 ${o((r) => r.name === "briefcase", Mr)}
 ${o((r) => r.name === "bug-ant", Or)}
 ${o((r) => r.name === "building-library", Er)}
 ${o((r) => r.name === "building-office-2", Fr)}
 ${o((r) => r.name === "building-office", Gr)}
 ${o((r) => r.name === "building-storefront", Hr)}
 ${o((r) => r.name === "cake", zr)}
 ${o((r) => r.name === "calculator", Ir)}
 ${o((r) => r.name === "calendar-date-range", Vr)}
 ${o((r) => r.name === "calendar-days", Wr)}
 ${o((r) => r.name === "calendar", Xr)}
 ${o((r) => r.name === "camera", jr)}
 ${o((r) => r.name === "chart-bar-square", Nr)}
 ${o((r) => r.name === "chart-bar", Qr)}
 ${o((r) => r.name === "chart-pie", Yr)}
 ${o((r) => r.name === "chat-bubble-bottom-center-text", Kr)}
 ${o((r) => r.name === "chat-bubble-bottom-center", Jr)}
 ${o((r) => r.name === "chat-bubble-left-ellipsis", Zr)}
 ${o((r) => r.name === "chat-bubble-left-right", _r)}
 ${o((r) => r.name === "chat-bubble-left", ro)}
 ${o((r) => r.name === "chat-bubble-oval-left-ellipsis", oo)}
 ${o((r) => r.name === "chat-bubble-oval-left", mo)}
 ${o((r) => r.name === "check-badge", eo)}
 ${o((r) => r.name === "check-circle", ao)}
 ${o((r) => r.name === "check", no)}
 ${o((r) => r.name === "chevron-double-down", to)}
 ${o((r) => r.name === "chevron-double-left", io)}
 ${o((r) => r.name === "chevron-double-right", po)}
 ${o((r) => r.name === "chevron-double-up", fo)}
 ${o((r) => r.name === "chevron-down", lo)}
 ${o((r) => r.name === "chevron-left", co)}
 ${o((r) => r.name === "chevron-right", $o)}
 ${o((r) => r.name === "chevron-up-down", uo)}
 ${o((r) => r.name === "chevron-up", so)}
 ${o((r) => r.name === "circle-stack", wo)}
 ${o((r) => r.name === "clipboard-document-check", ho)}
 ${o((r) => r.name === "clipboard-document-list", go)}
 ${o((r) => r.name === "clipboard-document", bo)}
 ${o((r) => r.name === "clipboard", Co)}
 ${o((r) => r.name === "clock", ko)}
 ${o((r) => r.name === "cloud-arrow-down", Ao)}
 ${o((r) => r.name === "cloud-arrow-up", yo)}
 ${o((r) => r.name === "cloud", So)}
 ${o((r) => r.name === "code-bracket-square", Bo)}
 ${o((r) => r.name === "code-bracket", Do)}
 ${o((r) => r.name === "cog-6-tooth", vo)}
 ${o((r) => r.name === "cog-8-tooth", Lo)}
 ${o((r) => r.name === "cog", Po)}
 ${o((r) => r.name === "command-line", Ro)}
 ${o((r) => r.name === "computer-desktop", Uo)}
 ${o((r) => r.name === "cpu-chip", qo)}
 ${o((r) => r.name === "credit-card", To)}
 ${o((r) => r.name === "cube-transparent", xo)}
 ${o((r) => r.name === "cube", Mo)}
 ${o((r) => r.name === "currency-bangladeshi", Oo)}
 ${o((r) => r.name === "currency-dollar", Eo)}
 ${o((r) => r.name === "currency-euro", Fo)}
 ${o((r) => r.name === "currency-pound", Go)}
 ${o((r) => r.name === "currency-rupee", Ho)}
 ${o((r) => r.name === "currency-yen", zo)}
 ${o((r) => r.name === "cursor-arrow-rays", Io)}
 ${o((r) => r.name === "cursor-arrow-ripple", Vo)}
 ${o((r) => r.name === "device-phone-mobile", Wo)}
 ${o((r) => r.name === "device-tablet", Xo)}
 ${o((r) => r.name === "divide", jo)}
 ${o((r) => r.name === "document-arrow-down", No)}
 ${o((r) => r.name === "document-arrow-up", Qo)}
 ${o((r) => r.name === "document-chart-bar", Yo)}
 ${o((r) => r.name === "document-check", Ko)}
 ${o((r) => r.name === "document-currency-bangladeshi", Jo)}
 ${o((r) => r.name === "document-currency-dollar", Zo)}
 ${o((r) => r.name === "document-currency-euro", _o)}
 ${o((r) => r.name === "document-currency-pound", rm)}
 ${o((r) => r.name === "document-currency-rupee", om)}
 ${o((r) => r.name === "document-currency-yen", mm)}
 ${o((r) => r.name === "document-duplicate", em)}
 ${o((r) => r.name === "document-magnifying-glass", am)}
 ${o((r) => r.name === "document-minus", nm)}
 ${o((r) => r.name === "document-plus", tm)}
 ${o((r) => r.name === "document-text", im)}
 ${o((r) => r.name === "document", pm)}
 ${o((r) => r.name === "ellipsis-horizontal-circle", fm)}
 ${o((r) => r.name === "ellipsis-horizontal", lm)}
 ${o((r) => r.name === "ellipsis-vertical", cm)}
 ${o((r) => r.name === "envelope-open", $m)}
 ${o((r) => r.name === "envelope", um)}
 ${o((r) => r.name === "equals", sm)}
 ${o((r) => r.name === "exclamation-circle", wm)}
 ${o((r) => r.name === "exclamation-triangle", hm)}
 ${o((r) => r.name === "eye-dropper", dm)}
 ${o((r) => r.name === "eye-slash", gm)}
 ${o((r) => r.name === "eye", bm)}
 ${o((r) => r.name === "face-frown", Cm)}
 ${o((r) => r.name === "face-smile", km)}
 ${o((r) => r.name === "film", Am)}
 ${o((r) => r.name === "finger-print", ym)}
 ${o((r) => r.name === "fire", Sm)}
 ${o((r) => r.name === "flag", Bm)}
 ${o((r) => r.name === "folder-arrow-down", Dm)}
 ${o((r) => r.name === "folder-minus", vm)}
 ${o((r) => r.name === "folder-open", Lm)}
 ${o((r) => r.name === "folder-plus", Pm)}
 ${o((r) => r.name === "folder", Rm)}
 ${o((r) => r.name === "forward", Um)}
 ${o((r) => r.name === "funnel", qm)}
 ${o((r) => r.name === "gif", Tm)}
 ${o((r) => r.name === "gift-top", xm)}
 ${o((r) => r.name === "gift", Mm)}
 ${o((r) => r.name === "globe-alt", Om)}
 ${o((r) => r.name === "globe-americas", Em)}
 ${o((r) => r.name === "globe-asia-australia", Fm)}
 ${o((r) => r.name === "globe-europe-africa", Gm)}
 ${o((r) => r.name === "h1", Hm)}
 ${o((r) => r.name === "h2", zm)}
 ${o((r) => r.name === "h3", Im)}
 ${o((r) => r.name === "hand-raised", Vm)}
 ${o((r) => r.name === "hand-thumb-down", Wm)}
 ${o((r) => r.name === "hand-thumb-up", Xm)}
 ${o((r) => r.name === "hashtag", jm)}
 ${o((r) => r.name === "heart", Nm)}
 ${o((r) => r.name === "home-modern", Qm)}
 ${o((r) => r.name === "home", Ym)}
 ${o((r) => r.name === "identification", Km)}
 ${o((r) => r.name === "inbox-arrow-down", Jm)}
 ${o((r) => r.name === "inbox-stack", Zm)}
 ${o((r) => r.name === "inbox", _m)}
 ${o((r) => r.name === "information-circle", re)}
 ${o((r) => r.name === "italic", oe)}
 ${o((r) => r.name === "key", me)}
 ${o((r) => r.name === "language", ee)}
 ${o((r) => r.name === "lifebuoy", ae)}
 ${o((r) => r.name === "light-bulb", ne)}
 ${o((r) => r.name === "link-slash", te)}
 ${o((r) => r.name === "link", ie)}
 ${o((r) => r.name === "list-bullet", pe)}
 ${o((r) => r.name === "lock-closed", fe)}
 ${o((r) => r.name === "lock-open", le)}
 ${o((r) => r.name === "magnifying-glass-circle", ce)}
 ${o((r) => r.name === "magnifying-glass-minus", $e)}
 ${o((r) => r.name === "magnifying-glass-plus", ue)}
 ${o((r) => r.name === "magnifying-glass", se)}
 ${o((r) => r.name === "map-pin", we)}
 ${o((r) => r.name === "map", he)}
 ${o((r) => r.name === "megaphone", de)}
 ${o((r) => r.name === "microphone", ge)}
 ${o((r) => r.name === "minus-circle", be)}
 ${o((r) => r.name === "minus-small", Ce)}
 ${o((r) => r.name === "minus", ke)}
 ${o((r) => r.name === "moon", Ae)}
 ${o((r) => r.name === "musical-note", ye)}
 ${o((r) => r.name === "newspaper", Se)}
 ${o((r) => r.name === "no-symbol", Be)}
 ${o((r) => r.name === "numbered-list", De)}
 ${o((r) => r.name === "paint-brush", ve)}
 ${o((r) => r.name === "paper-airplane", Le)}
 ${o((r) => r.name === "paper-clip", Pe)}
 ${o((r) => r.name === "pause-circle", Re)}
 ${o((r) => r.name === "pause", Ue)}
 ${o((r) => r.name === "pencil-square", qe)}
 ${o((r) => r.name === "pencil", Te)}
 ${o((r) => r.name === "percent-badge", xe)}
 ${o((r) => r.name === "phone-arrow-down-left", Me)}
 ${o((r) => r.name === "phone-arrow-up-right", Oe)}
 ${o((r) => r.name === "phone-x-mark", Ee)}
 ${o((r) => r.name === "phone", Fe)}
 ${o((r) => r.name === "photo", Ge)}
 ${o((r) => r.name === "play-circle", He)}
 ${o((r) => r.name === "play-pause", ze)}
 ${o((r) => r.name === "play", Ie)}
 ${o((r) => r.name === "plus-circle", Ve)}
 ${o((r) => r.name === "plus-small", We)}
 ${o((r) => r.name === "plus", Xe)}
 ${o((r) => r.name === "power", je)}
 ${o((r) => r.name === "presentation-chart-bar", Ne)}
 ${o((r) => r.name === "presentation-chart-line", Qe)}
 ${o((r) => r.name === "printer", Ye)}
 ${o((r) => r.name === "puzzle-piece", Ke)}
 ${o((r) => r.name === "qr-code", Je)}
 ${o((r) => r.name === "question-mark-circle", Ze)}
 ${o((r) => r.name === "queue-list", _e)}
 ${o((r) => r.name === "radio", ra)}
 ${o((r) => r.name === "receipt-percent", oa)}
 ${o((r) => r.name === "receipt-refund", ma)}
 ${o((r) => r.name === "rectangle-group", ea)}
 ${o((r) => r.name === "rectangle-stack", aa)}
 ${o((r) => r.name === "rocket-launch", na)}
 ${o((r) => r.name === "rss", ta)}
 ${o((r) => r.name === "scale", ia)}
 ${o((r) => r.name === "scissors", pa)}
 ${o((r) => r.name === "server-stack", fa)}
 ${o((r) => r.name === "server", la)}
 ${o((r) => r.name === "share", ca)}
 ${o((r) => r.name === "shield-check", $a)}
 ${o((r) => r.name === "shield-exclamation", ua)}
 ${o((r) => r.name === "shopping-bag", sa)}
 ${o((r) => r.name === "shopping-cart", wa)}
 ${o((r) => r.name === "signal-slash", ha)}
 ${o((r) => r.name === "signal", da)}
 ${o((r) => r.name === "slash", ga)}
 ${o((r) => r.name === "sparkles", ba)}
 ${o((r) => r.name === "speaker-wave", Ca)}
 ${o((r) => r.name === "speaker-x-mark", ka)}
 ${o((r) => r.name === "square-2-stack", Aa)}
 ${o((r) => r.name === "square-3-stack-3d", ya)}
 ${o((r) => r.name === "squares-2x2", Sa)}
 ${o((r) => r.name === "squares-plus", Ba)}
 ${o((r) => r.name === "star", Da)}
 ${o((r) => r.name === "stop-circle", va)}
 ${o((r) => r.name === "stop", La)}
 ${o((r) => r.name === "strikethrough", Pa)}
 ${o((r) => r.name === "sun", Ra)}
 ${o((r) => r.name === "swatch", Ua)}
 ${o((r) => r.name === "table-cells", qa)}
 ${o((r) => r.name === "tag", Ta)}
 ${o((r) => r.name === "ticket", xa)}
 ${o((r) => r.name === "trash", Ma)}
 ${o((r) => r.name === "trophy", Oa)}
 ${o((r) => r.name === "truck", Ea)}
 ${o((r) => r.name === "tv", Fa)}
 ${o((r) => r.name === "underline", Ga)}
 ${o((r) => r.name === "user-circle", Ha)}
 ${o((r) => r.name === "user-group", za)}
 ${o((r) => r.name === "user-minus", Ia)}
 ${o((r) => r.name === "user-plus", Va)}
 ${o((r) => r.name === "user", Wa)}
 ${o((r) => r.name === "users", Xa)}
 ${o((r) => r.name === "variable", ja)}
 ${o((r) => r.name === "video-camera-slash", Na)}
 ${o((r) => r.name === "video-camera", Qa)}
 ${o((r) => r.name === "view-columns", Ya)}
 ${o((r) => r.name === "viewfinder-circle", Ka)}
 ${o((r) => r.name === "wallet", Ja)}
 ${o((r) => r.name === "wifi", Za)}
 ${o((r) => r.name === "window", _a)}
 ${o((r) => r.name === "wrench-screwdriver", rn)}
 ${o((r) => r.name === "wrench", on)}
 ${o((r) => r.name === "x-circle", mn)}
 ${o((r) => r.name === "x-mark", en)}
`;
export {
  ic as outlineHeroIconTemplate
};
